/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-08-06 11:17:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\newspaper\edit\editRouter.js
 * @Description: 
 */
/*
author:wang.jiang 2016-1-16
newspapertype:0-待用稿
              1-今日稿
              2-上版稿
              目的是区分上班，退稿等操作不同平台下的请求方法
 */
'use strict';
angular.module('editctrNewspaperRouterModule', [])
    . config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('newspaperpic', {
                url: '/newspaperpic?papermetadataid&paperid&newspapertype&isfusion&isawaitrevise&channelid',
                views: {
                    '': {
                        templateUrl: './editingCenter/newspaper/edit/picDraft/editPic_tpl.html',
                        controller: 'EditctrNewspaperPicCtrl'
                    }
                }
            }).state('newspapertext', {
                url: '/newspapertext?papermetadataid&paperid&newspapertype&isfusion&isawaitrevise&channelid',
                views: {
                    '': {
                        templateUrl: './editingCenter/newspaper/edit/textDraft/editText_tpl.html',
                        controller: 'EditctrNewspaperTextCtrl'
                    }
                }
            });
    }]);
